<rde-smb-business-page-header [business]="content"> </rde-smb-business-page-header>
<rde-smb-business-page-body [business]="content"></rde-smb-business-page-body>
